import axios from '@/plugins/axios';
import { includes } from 'lodash';

const defRuleTemplateNameArr = [
  '全网基础模板',
  '全网询价模板',
  '全网招标模板',
  '全网竞价模板',
  '机构默认询价模板',
  '机构默认招标模板',
  '机构默认竞价模板'
];
export { defRuleTemplateNameArr };

export function isDefRuleTemplateName(templateName) {
  return includes(defRuleTemplateNameArr, templateName);
}

export function listRuleTemplate(params) {
  return axios.post('/ruleTemplate/list', params);
}

export function addRuleTmeplate(params) {
  return axios.post('/ruleTemplate/add', params);
}

export function editRuleTemplate(params) {
  return axios.post('/ruleTemplate/edit', params);
}

export function copyRuleTemplate(params) {
  return axios.post('/ruleTemplate/copy', params);
}

export function deleteRuleTemplateById(templateId) {
  return axios.post('/ruleTemplate/deleteById', { templateId: templateId });
}

export function getRuleTemplateById(templateId) {
  return axios.get('/ruleTemplate/getById', { params: { templateId: templateId } });
}

// 根据项目类型加载机构相应默认模板，如果机构默认模板不存在就使用全网默认模板
export function getProjectDefaultRuleTemplate(orgId, projectType) {
  let defTemplateName = '';
  if (projectType === 'PROJECT') {
    defTemplateName = '机构默认询价模板';
  } else if (projectType === 'BID') {
    defTemplateName = '机构默认招标模板';
  } else if (projectType === 'JINGJIA') {
    defTemplateName = '机构默认竞价模板';
  }

  return new Promise((resolve, reject) => {
    let resData = {};
    listRuleTemplate({ orgId: orgId, templateName: defTemplateName })
      .then(res => {
        let { data } = res;
        if (data.returnCode === '01') {
          if (data.data.length >= 1) {
            // 使用机构默认模板
            resData.templateId = data.data[0].templateId;
            resData.templateName = data.data[0].templateName;
          } else {
            // 使用全网默认模板
            if (projectType === 'PROJECT') {
              resData.templateId = 2;
              resData.templateName = '全网询价模板';
            } else if (projectType === 'BID') {
              resData.templateId = 3;
              resData.templateName = '全网招标模板';
            } else if (projectType === 'JINGJIA') {
              resData.templateId = 4;
              resData.templateName = '全网竞价模板';
            } else {
              resData.templateId = 2;
              resData.templateName = '全网询价模板';
            }
          }
          resolve(resData);
        } else {
          reject(new Error('加载默认模板失败'));
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}
